import { defineComponent as d, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as f, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "6279edc9-69d7-4bfa-91fe-6935fb7ea272" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#6279edc9-69d7-4bfa-91fe-6935fb7ea272)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#eee" d="m90.1 144.8 210.5-27.7L512 144.8v222.6l-209 32.4-213-32.4z"></path><path fill="#333" d="M0 0h512v144.8H28.2z"></path><path fill="#496e2d" d="M39.5 367.4H512V512H0z"></path><path fill="#d80027" d="M0 .1V512h.1L256 256.1 0 .1zm365.1 178.1a78 78 0 1 0 18.9 154 78 78 0 0 1 0-152.2 78.2 78.2 0 0 0-18.9-1.8z"></path><path fill="#d80027" d="m387.3 206.1 11 34h35.8l-29 21 11.1 34-29-21-28.9 21 11.1-34-29-21h35.8z"></path>', 5), g = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "eh",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), c = o(() => 256 + e.strokeWidth / 2);
    return (z, w) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", k, [
        e.flagName ? (s(), i("title", u, h(e.flagName), 1)) : n("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  N as default
};
//# sourceMappingURL=eh-37c3853f.js.map
